module.exports = __webpack_public_path__ + "img/about.a07aca75.webp";